import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '@/components/AuthLayout';
import { SignUpForm } from '@/widgets/SignUpForm';
import { useAuth } from '@/hooks/useAuth';
import { getPostAuthRedirect } from '@/utils/authRedirect';
import styles from '@/pages/LandingPage/styles.module.scss';

const SignUpPitch = () => {
  const { t } = useTranslation('auth');
  return (
    <>
      <span className={styles.eyebrow}>{t('seasonLabel')}</span>
      <h1 className={styles.heroTitle} style={{ margin: '18px 0 18px', fontSize: 'clamp(36px, 5vw, 56px)', lineHeight: 1.04, letterSpacing: '-1.2px' }}>
        <span dangerouslySetInnerHTML={{ __html: t('signUpPitch') }} />
      </h1>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--text)', maxWidth: 460, margin: '0 0 28px' }}>
        {t('signUpPitchSub')}
      </p>
      <div className={styles.proof} aria-label="Platform stats">
        <div className={styles.proofItem}><span className={styles.proofValue}>12,431</span><span className={styles.proofLabel}>{t('activeTournaments')}</span></div>
        <div className={styles.proofSep} aria-hidden="true" />
        <div className={styles.proofItem}><span className={styles.proofValue}>84K+</span><span className={styles.proofLabel}>{t('predictionsWeekly')}</span></div>
        <div className={styles.proofSep} aria-hidden="true" />
        <div className={styles.proofItem}><span className={styles.proofValue}>14</span><span className={styles.proofLabel}>{t('leaguesCovered')}</span></div>
      </div>
    </>
  );
};

const SignUpPage = () => {
  const { t } = useTranslation('auth');
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={getPostAuthRedirect(location, '/')} replace />;
  }

  return (
    <AuthLayout title={t('createAccount')} pitch={<SignUpPitch />}>
      <SignUpForm />
    </AuthLayout>
  );
};

export default SignUpPage;
